// SPDX-License-Identifier: AGPL-3.0-or-later
import Drafts from '@app/features/messaging/state/MessagingDrafts';
import {TextareaSegmentManager} from '@app/features/messaging/utils/TextareaSegmentManager';

/** Preserve mention identities when a rich chat draft is edited in Home's plain textarea. */
export function setAssistantDraft(channelId: string, text: string): void {
	const previous = Drafts.getDraft(channelId);
	const manager = new TextareaSegmentManager();
	manager.setSegments([...Drafts.getDraftSegments(channelId)]);
	const change = TextareaSegmentManager.detectChange(previous, text);
	manager.updateSegmentsForTextChange(change.changeStart, change.changeEnd, change.replacementLength);
	Drafts.createDraft(channelId, text, manager.getSegments());
}

export function getAssistantDraftForSend(channelId: string): string {
	const manager = new TextareaSegmentManager();
	manager.setSegments([...Drafts.getDraftSegments(channelId)]);
	return manager.displayToActual(Drafts.getDraft(channelId));
}
